module.exports = __webpack_public_path__ + "static/media/membrane.fa84d81c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/membrane.jpg
// module id = 469
// module chunks = 17